import React, { useContext } from "react";
import Datebox from "../../components/Datebox";
import "../../styles/pageTemplate.css";
import ArticleCard from "../../components/ArticleCard";
import Box from "@mui/material/Box";
import { ClientContext } from "../../../store/context";
import { usePost } from "../../hooks/Hooks";
import { baseURLWithoutPort, staticArticlesApi } from "../../api/GardenoApi";
import { convertToLanguage } from "../../utils/generalUtils";
import { homePageArticles, homePageImages } from "../../utils/constants";
import "../../styles/dateTimePickers.css";
import { useNavigate } from "react-router-dom";
function HomePage() {
  const navigate = useNavigate();
  const {
    language,
    setLanguage,
    pickUpDate,
    dropOffDate,
    pickUpLocation,
    pickUpTime,
    dropOffLocation,
    dropOffTime,
  } = React.useContext(ClientContext);
  const articleImages = [1, 2, 3, 4, 5, 6, 7];
  const [articles, articlesError] = usePost(
    staticArticlesApi.getAllValues,
    convertToLanguage(language),
    homePageArticles
  );
  return (
    <div className="page-content">
      <Box
        className="home-page-dates"
        sx={{ minHeight: { xs: "500px", lg: "500px" } }}
      >
        <div className="datebox-container">
          <Datebox
            onSearchClick={() => {
              if (
                pickUpDate &&
                dropOffDate &&
                pickUpLocation &&
                pickUpTime &&
                dropOffLocation &&
                dropOffTime
              ) {
                navigate("/fleet");
              }
            }}
          />
        </div>
      </Box>
      <Box
        className="home-article-container"
        sx={{ width: { xs: "100%", lg: "60%" } }}
      >
        {articles && (
          <React.Fragment>
            <ArticleCard
              image={`${baseURLWithoutPort}${homePageImages.welcomeToGardeno}`}
              title={articles[2]?.title}
              description={articles[2]?.text}
            />
            <ArticleCard
              image={`${baseURLWithoutPort}${homePageImages.onlineBooking}`}
              title={articles[1]?.title}
              description={articles[1]?.text}
            />
            <ArticleCard
              image={`${baseURLWithoutPort}${homePageImages.carRentalFleet}`}
              title={articles[0]?.title}
              description={articles[0]?.text}
            />
            <ArticleCard
              image={`${baseURLWithoutPort}${homePageImages.exceptionalCustomerService}`}
              title={articles[6]?.title}
              description={articles[6]?.text}
            />
            <ArticleCard
              image={`${baseURLWithoutPort}${homePageImages.greatValuePricing}`}
              title={articles[5]?.title}
              description={articles[5]?.text}
            />
            <ArticleCard
              image={`${baseURLWithoutPort}${homePageImages.convenientPickUp}`}
              title={articles[4]?.title}
              description={articles[4]?.text}
            />
            <ArticleCard
              image={`${baseURLWithoutPort}${homePageImages.trustInsurance}`}
              title={articles[3]?.title}
              description={articles[3]?.text}
            />
          </React.Fragment>
        )}
      </Box>
    </div>
  );
}

export default HomePage;
